import { render, staticRenderFns } from "./PosTableDetailDrink.vue?vue&type=template&id=6844c0a6&scoped=true&"
import script from "./PosTableDetailDrink.vue?vue&type=script&lang=js&"
export * from "./PosTableDetailDrink.vue?vue&type=script&lang=js&"
import style0 from "./PosTableDetailDrink.vue?vue&type=style&index=0&id=6844c0a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844c0a6",
  null
  
)

export default component.exports